import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_SERVICE_HISTORY } from './vehicleEntityConfigs';

const VehicleServiceHistory = () => <VehicleEntityGridPage config={VEHICLE_SERVICE_HISTORY} />;

export default VehicleServiceHistory;
